import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'header-company-list',
    templateUrl: 'header-company-list.component.html',
    styleUrls: ['header-company-list.component.scss'],
    standalone: false
})
export class HeaderCompanyListComponent implements AfterViewInit {
	@Input() companies: { externalId: string; fiscalNumber: string; companyName: string; companyNameAI: string; }[] = [];
	@Input() showFilter: boolean = false;

	@Output() companySelect = new EventEmitter<string>();

	@ViewChild('filterInput') filterInput: ElementRef;
	@ViewChild('companyListContainer') companyListContainer: ElementRef;

	public selectedIndex: number = 0;
	private _filter: string = '';

	ngAfterViewInit(): void {
		if (this.filterInput) {
			setTimeout(() => this.filterInput.nativeElement.focus(), 0);
		}
	}

	public get filter(): string {
		return this._filter;
	}

	public set filter(value: string) {
		this._filter = value;
		this.selectedIndex = 0;
	}

	public get filteredCompanies() {
		if (!this._filter) return this.companies;
		const f = this._filter.toLowerCase();
		return this.companies.filter(c =>
			c.companyNameAI.toLowerCase().includes(f) ||
			c.fiscalNumber.toLowerCase().includes(f)
		);
	}

	public onCompanyClick(externalId: string): void {
		this.companySelect.emit(externalId);
		this._filter = '';
		this.selectedIndex = 0;
	}

	public onFilterKeyDown(e: KeyboardEvent): void {
		const list = this.filteredCompanies;
		if (e.keyCode === 40) { // ArrowDown
			e.preventDefault();
			if (this.selectedIndex < list.length - 1) {
				this.selectedIndex++;
				this.scrollToSelected();
			}
		} else if (e.keyCode === 38) { // ArrowUp
			e.preventDefault();
			if (this.selectedIndex > 0) {
				this.selectedIndex--;
				this.scrollToSelected();
			}
		} else if (e.keyCode === 13 && list.length) { // Enter
			this.onCompanyClick(list[this.selectedIndex].externalId);
		}
	}

	private scrollToSelected(): void {
		if (this.companyListContainer) {
			const container = this.companyListContainer.nativeElement;
			const selectedElement = container.children[this.selectedIndex] as HTMLElement;
			if (selectedElement) {
				selectedElement.scrollIntoView({ block: 'nearest' });
			}
		}
	}
}
